import {Fetch} from "./Fetch";

export class LoginAPI {

    static async login(email, password){
        return await Fetch('POST','api/users/login',{
            email,
            password
        });
    }

    static async getUserInfo(){
        return await Fetch('GET','api/users/info');
    }

    static async updateUserInfo(firstName, lastName){
        return await Fetch('PUT','api/users/info', {
            first_name: firstName,
            last_name: lastName,
        });
    }

    static async logout(){
        return await Fetch('GET','api/users/logout');
    }

    static async resetPassword(email){
        return await Fetch('POST','api/users/reset-password', {email});
    }

    static async updatePassword(token, password, password_confirm){
        return await Fetch('POST','api/users/set-password', {token, password, password_confirm});
    }

    static async registerUser(payload){
        return await Fetch('POST','api/users/signup', payload);
    }

    static async getGoogleLoginRURI(payload={}) {
        return await Fetch('GET', 'api/users/google-login', payload);
    }

    static async googleLogin(payload){
        return await Fetch('POST','api/users/google-login', payload);
    }

    static async getFBLoginRURI(payload={}) {
        return await Fetch('GET', 'api/users/fb-login', payload);
    }

    static async facebookLogin(payload){
        return await Fetch('POST','api/users/fb-login', payload);
    }

    static async verifyUser(token){
        return await Fetch('POST','api/users/user-verify', {token});
    }

    static async changePassword(newPassword, newPasswordConfirmation, currentPassword){
        return await Fetch('PUT','api/users/change-password', {new_password: newPassword, current_password: currentPassword, new_password_confirmation: newPasswordConfirmation});
    }

}
